export type SourceLink = {
  /** The page's host, without `www.`, to show. */
  readonly host: string;
  /** The URL as the browser parsed it: the one the protocol check was run on. */
  readonly href: string;
};

/**
 * A source page as a link, or null unless it is an http(s) URL. The URL comes
 * from a page the model read, so anything else (a `javascript:` link, plain
 * text) is shown without a link rather than put in an href — and the href is
 * the parsed URL, never the raw text, so what was checked is what is linked.
 */
export function sourceLink(url: string): SourceLink | null {
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
      return null;
    }
    return { host: parsed.hostname.replace(/^www\./, ""), href: parsed.href };
  } catch {
    return null;
  }
}
